import { Outlet } from "react-router-dom";
import Nav from "../Nav/Nav";

import "./MainLayout.css";
import { USQSProvider } from "../../contexts/USQSProvider";
import { USQSUndoProvider } from "../../contexts/USQSUndoProvider";
import { USPositionProvider } from "../../contexts/USPositionProvider";
import { USUndoProvider } from "../../contexts/USUndoProvider";
import { SPPositionProvider } from "../../contexts/SPPositionProvider";
import { SPUndoProvider } from "../../contexts/SPUndoProvider";
import { SPQSProvider } from "../../contexts/SPQSProvider";
import { SPQSUndoProvider } from "../../contexts/SPQSUndoProvider";
import { GeneralPositionProvider } from "../../contexts/GeneralPositionProvider";

const MainLayout = () => {
  return (
    // <main className='App'>
    <div className='mainLayout'>
      <Nav />
      <GeneralPositionProvider>
        <SPQSUndoProvider>
          <SPQSProvider>
            <SPPositionProvider>
              <SPUndoProvider>
                <USPositionProvider>
                  <USUndoProvider>
                    <USQSProvider>
                      <USQSUndoProvider>
                        <Outlet />
                      </USQSUndoProvider>
                    </USQSProvider>
                  </USUndoProvider>
                </USPositionProvider>
              </SPUndoProvider>
            </SPPositionProvider>
          </SPQSProvider>
        </SPQSUndoProvider>
      </GeneralPositionProvider>
    </div>
    // </main>
  );
};

export default MainLayout;
